import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/comics';

export default function LatestUpdate() {
  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
              最近更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">每日新鲜漫画，追更不停歇</p>
          </div>
          <Link to="/category/all" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1 cursor-pointer">
            更多 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {latestUpdates.map(comic => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex gap-4 p-4 bg-white rounded-xl hover:bg-background-50 transition-colors cursor-pointer group border border-background-200/50"
            >
              <div className="w-20 h-28 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
                <img src={comic.cover} alt={comic.title} className="w-full h-full object-cover object-top" loading="lazy" />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">{comic.title}</h3>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-xs text-accent-500 font-medium whitespace-nowrap">
                      <i className="ri-star-fill w-3 h-3 inline-flex items-center justify-center"></i> {comic.rating}
                    </span>
                  </div>
                </div>
                <div>
                  <p className="text-xs text-foreground-500 line-clamp-1 mb-1">{comic.latestChapter}</p>
                  <div className="flex items-center gap-2">
                    {comic.tags.slice(0, 2).map(tag => (
                      <span key={tag} className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded text-[10px] whitespace-nowrap">{tag}</span>
                    ))}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}